import { LaunchDarklyFlags, useFlag } from '../../hooks'
import { useConsumerAccountIsInHardship } from '../../state'
import { useGetOrder, useHasOrderTotalOwed, useIsOrderConsumerLending, useGetOrderTransactionQuery } from '../../state/orders/hooks'
import { isValidMoney } from '../Money/utils'

export const useHasOrderChangePaymentDateEnabled = (orderId: string): boolean => {
  const order = useGetOrder(orderId)
  const hasOrderTotalOwed = useHasOrderTotalOwed(orderId)
  const isChangePaymentDateDisabled = useFlag(LaunchDarklyFlags.DisableChangePaymentDateButton, false)
  const isChangePaymentDateForConsumerLendingEnabled = useFlag(LaunchDarklyFlags.ChangePaymentDateForConsumerLendingEnabled, false)
  const isHardship = useConsumerAccountIsInHardship()
  const isOrderConsumerLending = useIsOrderConsumerLending(orderId)
  const isClearpayPartiallyMigrated = order?.clearpayPartiallyMigrated

  if (isHardship || !hasOrderTotalOwed || isClearpayPartiallyMigrated) {
    return false
  }

  return isOrderConsumerLending ? isChangePaymentDateForConsumerLendingEnabled : !isChangePaymentDateDisabled
}

export const useIsAFFOrder = (orderId: string): boolean => {
  const { data } = useGetOrderTransactionQuery(orderId)
  const isAFFEnabled = useFlag(LaunchDarklyFlags.ConsumerPortalAFFEnabled, false)
  const isAFFOrder =
    isAFFEnabled &&
    data?.paymentType === 'PBI' &&
    data?.orderSummary?.totalOriginalConsumerFees != null &&
    isValidMoney(data.orderSummary.totalOriginalConsumerFees)
  return isAFFOrder ?? false
}
